import TableCell from '@mui/material/TableCell';
import React, { useMemo } from 'react';
import AchReturnedChip from '@/components/AchReturnedChip/AchReturnedChip';
import { REFUND_METHOD, CHECK_TYPE_DB } from '@/utility';

const PaymentCategoryStatusCell = ({ refund, role, getTranslatedStatus }) => {
  const isAdmin = role === 'admin';
  const isAchReturned = refund.transaction_status === 'ACH-returned';
  const hasRefundMethod = Boolean(refund.refund_method);
  const hasTransactionStatus = Boolean(refund.transaction_status);
  const additionalInfo =
    refund?.additional_info || refund?.refund_additional_info;
  const hasImediatePayment = refund.pay_immediately;
  const checkTypeDisplay =
    '(Immediate payment ' +
    (refund.check_type === CHECK_TYPE_DB.PHYSICAL ? 'Check' : 'eCheck') +
    ')';

  const refundMethodDisplay = useMemo(() => {
    if (isAchReturned && isAdmin) {
      return '';
    }
    return hasRefundMethod ? refund.refund_method_string : 'N/A';
  }, [isAchReturned, isAdmin, hasRefundMethod, refund.refund_method_string]);

  const transactionStatusDisplay = useMemo(() => {
    if (!hasTransactionStatus) {
      return null;
    }

    if (isAchReturned && !isAdmin) {
      return (
        <span
          style={{
            fontSize: '12px',
            color: '#ff0000',
          }}>
          {getTranslatedStatus(refund.transaction_status) || ' '}
        </span>
      );
    }
    if (!isAchReturned) {
      return (
        <span style={{ fontSize: '12px' }}>
          {getTranslatedStatus(refund.transaction_status) || ' '}
        </span>
      );
    }

    return null;
  }, [
    hasTransactionStatus,
    isAchReturned,
    isAdmin,
    refund.transaction_status,
    getTranslatedStatus,
  ]);

  const shouldShowAdditionalInfo =
    ![REFUND_METHOD.VENMO, REFUND_METHOD.PAYPAL].includes(
      refund.refund_method,
    ) && additionalInfo;

  return (
    <TableCell align='center'>
      {isAdmin && <AchReturnedChip payment={refund} role={role} />}

      {refundMethodDisplay}
      {refundMethodDisplay && <br />}

      {hasImediatePayment && (
        <span style={{ fontSize: '12px' }}>{checkTypeDisplay}</span>
      )}
      {hasImediatePayment && <br />}

      {transactionStatusDisplay}

      {transactionStatusDisplay && <br />}

      {shouldShowAdditionalInfo && (
        <span style={{ fontSize: '12px' }}>({additionalInfo})</span>
      )}
    </TableCell>
  );
};

export default PaymentCategoryStatusCell;
